<script setup lang="ts">
import { useTemplateRef } from 'vue';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import type { MenuItem } from 'primevue/menuitem';

const { title, description, items } = defineProps<{
  title: string;
  description: string;
  items: MenuItem[];
}>();

const menuRef = useTemplateRef('menu');

function showMenu(event: Event) {
  const menu = menuRef.value;
  if (!menu) throw new Error('Menu not found!');
  menu.show(event);
}
</script>

<template>
  <Button severity="secondary" class="toggle-item" @click="showMenu($event)">
    <div class="icon"><slot name="icon"></slot></div>
    <strong class="title">{{ title }}</strong>
    <span class="description">{{ description }}</span>
  </Button>
  <Menu :popup="true" :model="items" ref="menu"></Menu>
</template>

<style scoped>
.toggle-item {
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: auto auto;
  justify-content: start;
}

.icon {
  grid-row: 1/3;
  grid-column: 1;
  align-self: center;
}

.title {
  grid-row: 1;
  grid-column: 2;
  font-weight: 400;
  justify-self: start;
}

.description {
  grid-row: 2;
  grid-column: 2;
  justify-self: start;
}
</style>
